import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import IconLabel from './IconLabel'
import {FundFilled} from '@ant-design/icons'

const VideoProduct = ({product, productAvailability}) => {
  const {advertisingTypes} = productAvailability
  const variants = advertisingTypes.reduce((acc, item) => {
    acc[item.type] = item.name
    return acc
  }, {})

  const label = get(product, 'advertisingVariants', [])
    .map(v => variants[v])
    .filter(v => v)
    .join(', ')

  return (
    <div className="selected-product-options AdvertisingProduct">
      <IconLabel icon={<FundFilled />} label={label} />
    </div>
  )
}

VideoProduct.propTypes = {
  product: PropTypes.object.isRequired,
  productAvailability: PropTypes.object.isRequired,
}

export default VideoProduct
